export enum RoutesPath {
  PreSimulation = '',
  Contact = 'contact',
  Error = 'error',
  SimulationResult = 'simulation-result',
  BorrowerSelection = 'borrower-selection',
}
